import { Trans, useTranslation } from 'next-i18next';

const MobileBeddingLinensSection = () => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$linensBeddingSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$mobBeddingLinens' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const imgPath = '/images/homePage/linensBeddingSection/';
  return (
    <section className="base-section linens-bedding-section hp-section hp-mobile-viewport">
      <div className="content-section">
        <h2 className="mob-section-title linens colored">{t('linensTitle')}</h2>
      </div>
      <div className="product-grid linens">
        <a href={tLink('texturedSham')} className="item1">
          <picture>
            <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
            <img
              src={`${imgPath}mob-pillow.webp`}
              alt={`${tButton('shopNow')}: ${t('pillowShamTitle')} `}
              width={702}
              height={458}
              loading="eager"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <span>
            <Trans i18nKey="pillowShamTitle" t={t} components={{ span: <span /> }} />
          </span>
        </a>
        <div className="copy">
          <p>{t('pillowShamDescription')}</p>
        </div>
        <a href={tLink('beddingSet')} className="item2">
          <picture>
            <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
            <img
              src={`${imgPath}mob-bedding.webp`}
              alt={`${tButton('shopNow')}: ${t('beddingSetTitle')} `}
              width={295}
              height={468}
              loading="eager"
              decoding="async"
              fetchPriority="low"
            />
          </picture>

          <span>{t('beddingSetTitle')}</span>
        </a>
        <a href={tLink('texturedLinenSet')} className="item3">
          <img
            src={`${imgPath}mob-linen.webp`}
            alt={`${tButton('shopNow')}: ${t('texturedLinenTitle')} `}
            width={295}
            height={229}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <span>{t('texturedLinenTitle')}</span>
        </a>
      </div>
      <div className="content-section">
        <h2 className="mob-section-title bedding colored">{t('beddingTitle')}</h2>
      </div>
      <div className="product-grid bedding">
        <a href={tLink('pillowcases')} className="item1">
          <img
            src={`${imgPath}mob-pillowcases.webp`}
            alt={`${tButton('shopNow')}: ${t('pillowcasesTitle')} `}
            width={702}
            height={458}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <span>{t('pillowcasesTitle')}</span>
        </a>
        <a href={tLink('fittedSheet')} className="item2">
          <img
            src={`${imgPath}mob-sheet-set.webp`}
            alt={`${tButton('shopNow')}: ${t('fittedSheetTitle')} `}
            width={295}
            height={468}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <span>{t('fittedSheetTitle')}</span>
        </a>
        <a href={tLink('flatSheets')} className="item3">
          <img
            src={`${imgPath}mob-flat-sheets.webp`}
            alt={`${tButton('shopNow')}: ${t('flatSheetsTitle')} `}
            width={295}
            height={229}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <span>{t('flatSheetsTitle')}</span>
        </a>
      </div>
    </section>
  );
};
export default MobileBeddingLinensSection;
